<template>
  <div class="language-selector dropdown" v-dropdown.closeOnMenuClick>
    <a class="language-selector-button dropdown-toggle" href="/" @click.prevent="closeMenu">
      <span v-if="variant === 'all'">Resources&nbsp;<i class="fa fa-caret-down" /></span>
      <span v-else>{{ variant | capitalizeFirstCharacter }}&nbsp;<i class="fa fa-caret-down" /></span>
    </a>
    <div class="dropdown-menu" aria-labelledby="dropdownMenuButton" style="width: auto !important; min-width: 8rem !important; left: auto;" v-if="$mq === 'mobile'">
      <div class="dropdown-menu-content">
        <div v-for="item in items" v-if="(item.meta.title !== 'Automation' || (item.meta.title === 'Automation' && isFlowAvailable)) && (access !== 'User' || (access === 'User' && item.meta.user))" :class="{ 'active': item.meta.title === current }">
          <router-link :to="{ name: item.name }">
            <div class="dropdown-item plain-link-item">
              <span @click="openModal">{{ item.meta.title }}</span>
            </div>
          </router-link>
        </div>
      </div>
    </div>
    <div class="dropdown-menu" aria-labelledby="dropdownMenuButton" style="width: auto !important; min-width: 16rem !important; left: auto;" v-else>
      <div class="dropdown-menu-content">
        <div v-for="item in items" v-if="(item.meta.title !== 'Automation' || (item.meta.title === 'Automation' && isFlowAvailable)) && (access !== 'User' || (access === 'User' && item.meta.user))" :class="{ 'active': item.meta.title === current }">
          <router-link :to="{ name: item.name }">
            <div class="dropdown-item plain-link-item">
              <span @click="openModal">{{ item.meta.title }}</span>
            </div>
          </router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { mapActions } from 'vuex'
  import jwtDecode from 'jwt-decode'
  import menu from '../../../store/modules/menu'
  import eventBus from '../event-bus.js'

  export default {
    name: 'object-selector',

    mounted: function () {
      var self = this
      const token = localStorage.getItem('fonestorm-token')
      const decoded = jwtDecode(token)
      self.access = decoded.authorization.access
    },

    props: {
      variant: {
        type: String,
        default: 'all'
      }
    },

    data () {
      return {
        items: this.variant === 'all' ? menu.state.items : menu.state[this.variant],
        access: null
      }
    },

    computed: {
      current () {
        return this.$route.meta.parent || this.$route.meta.title
      },
      isFlowAvailable () {
        return localStorage.getItem('flow-token') || false
      }
    },

    methods: {
      ...mapActions(['closeMenu']),
      openModal () {
        eventBus.bus.$emit('openObjectModal')
      }
    }
  }
</script>

<style lang="scss">
  @import "../../../sass/variables";
  @import "~bootstrap/scss/mixins/breakpoints";
  @import "~bootstrap/scss/functions";
  @import "~bootstrap/scss/variables";

  .language-selector {
    display: flex;
    max-width: 100%;
    height: 100%;
    padding: 0;
    flex-basis: 0;
    flex-grow: 1;
    align-items: center;
    justify-content: center;

    .language-selector-button {
      display: flex;
      align-items: center;
      justify-content: center;
    }

    .flag-icon-large {
      width: 31px;
      height: 23px;
    }

    .flag-icon-small {
      min-width: 22px;
      height: 17px;
    }

    .dropdown-toggle {
      padding: 0;

      &:after {
        display: none;
      }
    }

    &.show {
      &:after {
        position: absolute;
        right: calc(50% - 10px);
        bottom: -$dropdown-mobile-show-b;
        display: block;
        width: 0;
        height: 0;
        content: '';
        border-left: 10px solid transparent;
        border-right: 10px solid transparent;
        border-bottom: 10px solid $fractel-teal;
        z-index: 2;
      }

      .dropdown-menu {
        left: auto;
        margin-top: $dropdown-mobile-show-b;

        &.last {
          right: 0;
        }

        @include media-breakpoint-up(lg) {
          right: auto;
          left: 12px;
          margin-top: 12px;
        }
      }
    }

    .dropdown-menu {
      min-width: 8rem;
      max-width: 11rem;
      margin-top: $dropdown-show-b;
      padding: 0;
      background-color: $dropdown-background;
      box-shadow: $dropdown-box-shadow;

      @include media-breakpoint-up(lg) {
        top: 42px;
      }
    }

    .dropdown-item {
      display: flex;
      align-items: center;
      height: 38px;
      padding: 9px 12px;

      &.active {
        color: $vue-green;
        background-color: $fractel-teal;
      }

      &:hover {
        background-color: $fractel-dark-teal;
      }

      &:last-child {
        padding-top: 8px;
        padding-bottom: 10px;
      }
    }

    .dropdown-item-text {
      padding-left: 0;
      font-size: 5*$font-size-base/6;
      line-height: 1.25;
    }
  }

  .dropdown-item > a {
    color: $white;

    &.active {
      color: $lighter-gray;
    }

    &:hover {
      color: $lighter-gray;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/layout/navbar/ObjectSelector.vue